import { MantineProvider } from '@mantine/core'
import { DatesProvider } from '@mantine/dates'
import { Notifications } from '@mantine/notifications'
import type { ReactNode } from 'react'
import { themeFor } from '../lib/theme'

// CSR (inertia.tsx) と SSR (ssr.tsx) で共有する Mantine 周り Provider 一式。
// theme / forceColorScheme は呼び出し側が渡す page component 名で決定し、
// CSR/SSR で同じ判定ロジックを共有することで hydration 不整合を防ぐ。
export function AppProviders({
  component,
  children,
}: {
  component: string
  children: ReactNode
}) {
  const { theme, forceColorScheme } = themeFor(component)
  return (
    <MantineProvider theme={theme} forceColorScheme={forceColorScheme}>
      <DatesProvider settings={{ locale: 'ja', firstDayOfWeek: 0 }}>
        {/* containerWidth はコンテナの max-width で、通知は常にこの幅に従う。通知側に width を
            指定してもコンテナは既定幅のままなのではみ出し、中央からずれる (実測)。移転告知
            (issue #202) の 2 行を収めるため、ここで指定している。 */}
        <Notifications position="top-center" zIndex="var(--z-notification)" containerWidth={600} />
        {children}
      </DatesProvider>
    </MantineProvider>
  )
}
